import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_EMAIL, LEGAL_ADDRESS } from '../../seoConfig';

const FOOTER_COLUMNS = [
  {
    heading: 'Company',
    links: [
      { label: 'About Us', to: '/about' },
      { label: 'Blog', to: '/blog' },
      { label: 'Privacy Policy', to: '/privacy' },
      { label: 'Terms of Service', to: '/terms' },
    ],
  },
  {
    heading: 'Product',
    links: [
      { label: 'Features', to: '/features' },
      { label: 'Waitlist & Updates', to: '/waitlist' },
    ],
  },
];

const SiteFooter = () => (
  <footer className="pt-16 pb-10 px-8 border-t border-white/5">
    <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 mb-12 text-left">
      <div>
        <span className="font-bold tracking-[0.2em] text-sm text-white">SaniQ</span>
        <p className="text-white/30 text-xs leading-relaxed mt-4 max-w-xs">
          The world's first intelligent disinfectant door mat. Launching in Australia, 2027.
        </p>
      </div>
      {FOOTER_COLUMNS.map((col) => (
        <div key={col.heading}>
          <p className="text-white text-[11px] uppercase tracking-widest font-bold mb-4">{col.heading}</p>
          <ul className="flex flex-col gap-3">
            {col.links.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="text-white/45 text-xs uppercase tracking-widest hover:text-cyan-400 transition-colors">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>

    <div className="max-w-2xl mx-auto mb-8 p-6 rounded-2xl bg-white/[0.02] border border-white/5 text-center">
      <p className="text-white/30 text-xs leading-relaxed uppercase tracking-widest">
        The future of home and workplace hygiene is almost here. SaniQ - because what you can't see can still hurt you.
      </p>
    </div>

    <div className="text-center">
      <p className="text-white/20 text-[10px] uppercase tracking-widest">
        © 2026 SaniQ. All rights reserved. {LEGAL_ADDRESS}
      </p>
      <p className="text-white/20 text-[10px] uppercase tracking-widest mt-2 flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
        <a href={`mailto:${CONTACT_EMAIL}`} className="text-cyan-400/80 hover:text-cyan-300 transition-colors normal-case">{CONTACT_EMAIL}</a>
      </p>
    </div>
  </footer>
);

export default SiteFooter;
